import { PosterVariant, useFragmentPosterPolling } from '../hooks/useFragmentPosterPolling';
import { FragmentCardPoster } from './VideoFragmentCardPoster';

export type FragmentCardPosterWithPollingProps = {
  fragmentId: string;
  posterSrc: string | null;
  variant: PosterVariant | null;
};

/**
 * Wrapper around FragmentCardPoster that polls the BFF for the fragment when posterSrc is null.
 * When the backend returns poster data, the resolved URL is shown without updating the list cache.
 */
export function FragmentCardPosterWithPolling({
  posterSrc,
  fragmentId,
  variant,
}: FragmentCardPosterWithPollingProps) {
  const resolvedPosterSrc = useFragmentPosterPolling(fragmentId, variant, posterSrc === null);
  const effectivePosterSrc = posterSrc ?? resolvedPosterSrc;

  return <FragmentCardPoster posterSrc={effectivePosterSrc} />;
}
